import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
  makeTextFieldAutoFocus,
  makeTextFieldClear,
  makeTextFieldIcon,
  TextField,
} from 'shared/ui/TextField'
import { TimePicker, DropdownPlaceholder } from 'shared/ui'
import styles from './styles.module.scss'

type IQuietHoursTimePicker = {
  field: 'start' | 'end'
  setTime: (date: Date | null, field: 'start' | 'end') => void
  getTime: (field: 'start' | 'end') => Date
}

export const QuietHoursTimePicker = observer(
  ({ field, setTime, getTime }: IQuietHoursTimePicker) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
      <TimePicker
        onChange={(date) => setTime(date, field)}
        selected={getTime(field)}
        customContent={({ dropdownItems, handleChange, inputValue, onBlur, onChangeRaw }) => {
          return (
            <DropdownPlaceholder
              items={dropdownItems}
              onChange={handleChange}
              placeholder={inputValue || 'Select time'}
              onChangeOpen={(isOpen) => setIsOpen(isOpen)}
              topListComponent={() => (
                <div className={styles.searchInputWrap}>
                  <TextField
                    variant={'integrated'}
                    size={'small'}
                    InputProps={{
                      placeholder: 'Search time',
                      onKeyDown: (event) => {
                        if (event.code === 'Enter') {
                          onBlur()
                        }
                      },
                    }}
                    value={inputValue}
                    onChange={onChangeRaw}
                    onBlur={onBlur}
                    mainActions={[makeTextFieldAutoFocus({ focusTrigger: isOpen ? 'open' : '' })]}
                    leftActions={[
                      makeTextFieldIcon({ icon: 'clock', className: styles.timePickerActions }),
                    ]}
                    rightActions={[makeTextFieldClear()]}
                  />
                </div>
              )}
              textPlaceholderProps={{
                variant: 'stroke',
                size: 'small',
                className: styles.inputTimePicker,
                rightActions: [
                  makeTextFieldIcon({
                    icon: 'chevronDown',
                    color: 'var(--content-neutral-primary)',
                  }),
                ],
                leftActions: [
                  makeTextFieldIcon({
                    icon: field === 'end' ? 'minusCircle' : 'check2',
                    color: field === 'end' ? 'var(--red-60)' : 'var(--green-70)',
                  }),
                ],
              }}
            />
          )
        }}
        textFieldPlaceholderProps={{
          variant: 'stroke',
          leftActions: [],
          rightActions: [
            makeTextFieldIcon({
              icon: 'chevronDown',
              color: 'var(--content-neutral-primary)',
            }),
          ],
        }}
        topListTextFieldProps={{
          leftActions: [],
          readOnly: true,
        }}
      />
    )
  }
)
